import React, { FC, useMemo } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Benefits from '~/modules/feature-access/components/Benefits';
import ParaphraserLevelAnimation from '~/modules/feature-access/components/ParaphraserLevelAnimation';
import { getBenefitsList } from '~/modules/feature-access/helpers';
import { FeatureKey, FeatureModule } from '~/modules/feature-access/policy';
import projectConfig from '~/projects/config';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  paraphraserLevel?: string;
};

const ParaphraserLevel: FC<Props> = ({ paraphraserLevel }) => {
  const { t } = useTranslation();

  const benefits = useMemo(() => {
    return getBenefitsList(t)
      .filter(
        (el) =>
          !(
            el.key === FeatureKey.PARAPHRASER_LEVEL &&
            el.module === FeatureModule.PARAPHRASE_TEXT
          ),
      )
      .sort(
        (a, b) =>
          Number(b.module === FeatureModule.PARAPHRASE_TEXT) -
          Number(a.module === FeatureModule.PARAPHRASE_TEXT),
      );
  }, []);

  return (
    <div className={styles.container}>
      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        {t('modal:feature_unlock.paraphraser_level_title', {
          project: projectConfig.getProjectName(),
          defaultValue:
            'Upgrade to {{project}} Unlimited To Set Paraphrase Level',
        })}
      </Typography>

      <div className={styles.animation}>
        <ParaphraserLevelAnimation paraphraserLevel={paraphraserLevel} />
      </div>

      <Benefits benefits={benefits} />
    </div>
  );
};

export default ParaphraserLevel;
